/** The two states every data screen has besides content. */
export function Loading({ what }: { what: string }) {
  return <div className="loading muted">Loading {what}…</div>;
}

export function Failed({ what, message }: { what: string; message: string }) {
  return (
    <div className="note warn">
      <b>Could not load {what}</b>
      {message} — this is a failure to read, not an empty list. Nothing has been lost.
    </div>
  );
}
